import { FaBitcoin, FaDesktop } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { IoEllipsisHorizontalSharp } from "react-icons/io5";
import { useEffect, useState } from "react";

// ─── Data ────────────────────────────────────────────────────────────────────

const SERVICES = [
  {
    to: "/crypto-services",
    icon: <FaBitcoin size={22} color="#C4622D" />,
    label: "Crypto Services",
    desc: "Wallet recovery, transaction issues, token disputes, swapping errors, migration problems, and all crypto-related matters.",
    tags: ["Recovery", "Wallet Compromise", "Transaction Glitch", "Staking", "NFT Issues", "Airdrop"],
  },
  {
    to: "/contact",
    icon: <FaDesktop size={22} color="#C4622D" />,
    label: "Hacking & Blackmail",
    desc: "Account breaches, data extortion, social media hijacking, and unauthorized access to your digital identity.",
    tags: ["Account Recovery", "Social Media", "Email Access", "Data Extortion"],
  },
  {
    to: "/contact",
    icon: <IoEllipsisHorizontalSharp size={22} color="#C4622D" />,
    label: "Others",
    desc: "Not sure where your issue fits? Reach out and we'll point you in the right direction.",
    tags: [],
  },
];

// ─── Component ───────────────────────────────────────────────────────────────

function Services() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="bg-[#F7F3EC] min-h-screen px-8 py-20">
      <div className="max-w-[800px] mx-auto">

        <p
          className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-4 transition-all duration-500"
          style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(10px)" }}
        >
          What We Do
        </p>

        <h1
          className="sc-serif text-[clamp(2rem,4vw,3rem)] text-[#1C1A16] leading-[1.1] mb-3 transition-all duration-500"
          style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(14px)", transitionDelay: "80ms" }}
        >
          Select the service you need
        </h1>

        <p
          className="text-[#6B6457] text-[0.9rem] mb-14 transition-all duration-500"
          style={{ opacity: visible ? 1 : 0, transitionDelay: "160ms" }}
        >
          Choose the category that best describes your situation.
        </p>

        <div className="flex flex-col">
          {SERVICES.map((s, i) => (
            <NavLink
              key={s.label}
              to={s.to}
              className="group flex gap-7 items-start py-8 border-b border-[#E0D9CC] no-underline
                         border-l-[3px] border-l-transparent pl-3
                         hover:border-l-[#C4622D] hover:bg-[#EDE7D9] hover:pl-6 transition-all"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? "none" : "translateY(12px)",
                transition: "all 0.5s ease",
                transitionDelay: `${200 + i * 80}ms`,
              }}
            >
              <div className="mt-[3px] shrink-0">{s.icon}</div>

              <div className="flex-1">
                <h2 className="text-[1.05rem] font-semibold text-[#1C1A16] mb-2">{s.label}</h2>
                <p className="text-[#6B6457] text-[0.875rem] leading-[1.65] mb-3">{s.desc}</p>

                {s.tags.length > 0 && (
                  <div className="flex flex-wrap gap-1.5">
                    {s.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-1 bg-[#EDE7D9] text-[#9C9488] text-[0.7rem] font-semibold tracking-[0.05em] border border-[#D6CDB8]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <span className="text-[#C4622D] text-lg mt-[3px] shrink-0">→</span>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;